import { render, staticRenderFns } from "./assest.vue?vue&type=template&id=2d7e17ec&scoped=true"
import script from "./assest.vue?vue&type=script&lang=js"
export * from "./assest.vue?vue&type=script&lang=js"
import style0 from "./assest.vue?vue&type=style&index=0&id=2d7e17ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7e17ec",
  null
  
)

export default component.exports